import { decodeTime } from "ulid";
/**
 * Session Class
 */
export class Session {
    #collection;
    id;
    /**
     * Construct Session
     * @param collection Collection
     * @param id Id
     */
    constructor(collection, id) {
        this.#collection = collection;
        this.id = id;
    }
    /**
     * Convert to string
     * @returns String
     */
    toString() {
        return this.name;
    }
    /**
     * Whether this object exists
     */
    get $exists() {
        return !!this.#collection.getUnderlyingObject(this.id).id;
    }
    /**
     * Time when this session was created
     */
    get createdAt() {
        return new Date(decodeTime(this.id));
    }
    /**
     * Whether this is the current session
     */
    get current() {
        return this.id === this.#collection.client.sessionId;
    }
    /**
     * Name
     */
    get name() {
        return this.#collection.getUnderlyingObject(this.id).name;
    }
    /**
     * Rename a session
     * @param name New name
     */
    async rename(name) {
        await this.#collection.client.api.patch(`/auth/session/${this.id}`, {
            friendly_name: name,
        });
        this.#collection.updateUnderlyingObject(this.id, "name", name);
    }
    /**
     * Delete a session
     */
    async delete() {
        await this.#collection.client.api.delete(`/auth/session/${this.id}`);
        this.#collection.delete(this.id);
    }
}
